import { ResponsiveContainer, BarChart, XAxis, YAxis, Bar } from 'recharts';

import './TopReducedWasteRateBlock.scss';

interface TopReducedWasteRateBlockProps {
  graphData: any[];
  tableData: any[];
};

const TopReducedWasteRateBlock = (props: TopReducedWasteRateBlockProps) => {
  return (
    <div className='split-container-top-rwr'>
      <div className='graph'>
        <ResponsiveContainer width='100%' height={480}>
          <BarChart
            layout='vertical'
            margin={{left: 10, right: 40}}
            height={480}
            data={props.graphData}
          >
            <XAxis type='number' minTickGap={10} domain={[0, 100]} />
            <YAxis type='category' dataKey='name' width={100} />
            <Bar dataKey='value' fill='#f66244' barSize={60} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className='table'>
        <table>
          <tr>
            <th style={{ width: '40%' }}>Customer Site</th>
            <th style={{ width: '20%' }}>Reduced Waste Rate %</th>
            <th style={{ width: '20%' }}>Total Waste CY, t</th>
            <th style={{ width: '20%' }}>Total Waste YA, t</th>
          </tr>
          {props.tableData.map((rwr, idx) =>
            <tr key={'top-rwr-export-' + idx} className={idx < 5 ? 'top-five-rows' : ''}>
              <td style={{ width: '40%' }}>{rwr[0]}</td>
              <td style={{ width: '20%' }}>{rwr[1]}</td>
              <td style={{ width: '20%' }}>{rwr[2]}</td>
              <td style={{ width: '20%' }}>{rwr[3]}</td>
            </tr>
          )}
        </table>
      </div>
    </div>
  );
};

export default TopReducedWasteRateBlock;